module.exports = __webpack_public_path__ + "static/media/shape1.svg:Zone.7a821669.Identifier";